import React, { useEffect, useRef, useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import CustomTable from '../../../shared/components/table/custom-table';
import { FloatingButtonContainer, InnerButton } from '../../../shared/components/buttons/floating-button-container';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import useNotification from '../../../shared/hooks/useNotification';
import { useApi } from '../../../shared/hooks/useApi';
import { LoaderComponent } from '../../../shared/components/loaders/page-loader';
import _ from 'lodash';
import { ETCAppConfig } from '../../../shared/app-configs/etc-app-configs';
import { mapPayload } from '../etc-models/IInputEtcComponents-model';
import { Utills } from '../../../shared/app-configs/utilit';
import { StyledButton } from '../../../shared/components/buttons/custom-button';

const InputEtcComponentsDetails = () => {
  const { notify } = useNotification()
  const navigate = useNavigate();
  const { etcId, formtype } = useParams<string>()
  const [data, setData] = useState<any[]>([]);
  const { loading, executeGet } = useApi();
  // Refs for Form Steps
  const componentInfoRef = useRef<any>(null);
  const formRefs = [componentInfoRef];

  const fetchInputEtcComponentDetails = async () => {
    try {
      const response: any = await executeGet(ETCAppConfig.GET_INPUT_ETC_COMPONENTS_DETAILS, { etcId: etcId });
      Utills.cl("response", response)
      const result = mapPayload(response.data.inputTcComponentInformation, etcId);
      Utills.cl("result", result)    
      setData(result.inputTcComponentInformation);
    } catch (err) {
      console.error('Failed to fetch Inpur Etc Components Details:', err);
    }
  }

  useEffect(() => {
    fetchInputEtcComponentDetails()
  }, []);

  const columns: MRT_ColumnDef<any>[] = [
    { accessorKey: 'inputTcProductNo', header: 'Input eTC Product N.o', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcProductComponentNo', header: 'Input eTC Product Component No.', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentDetail', header: 'Input eTC Component Detail', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentInfoTrimsExcluded', header: 'Input eTC Component Info Trims Excluded', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentInfoAssociatedTc', header: 'Input eTC Component Info Associated TC', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentInfoFiberLength', header: 'Input eTC Component Info Fiber Length', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentInfoYarnCount', header: 'Input eTC Product Component Info Yarn Count', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentInfoFabricWeightAndConstruct', header: 'Input eTC Component Info Fabric Weight And Construct', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentInfoFabricWeightOfFinishedProduct', header: 'Input eTC Component Info Fabric Weight of Finished Product', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentNetShippingWeight', header: 'Input eTC Component Net Shipping Weight', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentSupplementaryWeight', header: 'Input eTC Component Supplementary Weight', minSize: 60, maxSize: 150 },
    { accessorKey: 'inputTcComponentInfoAdditional', header: 'Input eTC Component Info Additional', minSize: 60, maxSize: 150 },
  ];
  const handleSave = async () => {
    navigate(`/etc/${formtype}/input-etc-product-details/${etcId}`)    
  }
  const renderDetailPanel = ({ row }: { row: any }) => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 5,
          gap: 4,
          width: '50%',
        }}
      >
        {/* Product Component Standard Information */}
        <Box sx={{ width: '100%', textAlign: 'left', mb: 3 }} display="grid">
          <Typography variant="body2" fontWeight="400" sx={{ mb: 1 }}>
            eTC Components Details
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: 'inputTcComponentStandardLabelGrade',
                header: 'Standard Label Grade',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcComponentCertifiedWeight',
                header: 'Certified Weight (kg)',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcComponentCertifiedWeightUsed',
                header: 'Certified Weight Used (kg)',
                minSize: 60,
                maxSize: 150,
              }
            ]}
            data={data[0].inputTcComponentStandardInformation}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
        <Divider />
        {/* Raw Material Composition */}
        <Box sx={{ width: '100%', textAlign: 'left' }} display="grid">
          <Typography variant="body2" fontWeight="400" sx={{ mb: 1 }}>
            Raw Material Composition
          </Typography>
          <CustomTable
            columns={[
              {
                accessorKey: 'inputTcComponentRawMaterialCode',
                header: 'Raw Material Code',
                minSize: 60,
                maxSize: 150,
              },
              {
                accessorKey: 'inputTcComponentRawMaterialPercentage',
                header: 'Raw Material Percentage',
                minSize: 60,
                maxSize: 150,
              },
            ]}
            data={data[0].
              inputComponentRawMaterialInformation}
            enableRowActions={false}
            enableTopToolbar={false}
            enableBottomToolbar={false}
          />
        </Box>
      </Box>
    );
  };

  return (
    <>
      {loading ? <LoaderComponent /> : <>
        <Box display="grid">
          <CustomTable
            columns={columns}
            data={data}
            enableTopToolbar={false}
            enableBottomToolbar={true}
            renderDetailPanel={renderDetailPanel}
          />
        </Box>
        <Box sx={{
          display: "flex", justifyContent: "flex-end", mt: 2
        }}>
          <StyledButton variant="contained" onClick={handleSave}>
            Next
          </StyledButton>
          <NavLink to="/tc-dashboard">
            <StyledButton variant="contained">
              Cancel
            </StyledButton>
          </NavLink>
        </Box>
      </>}
    </>
  );
};

export default InputEtcComponentsDetails;